import React, { useState } from 'react';
import { Play, Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const LiveCodePreview: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [output, setOutput] = useState('');

  const code = `const learn = (skill) => {
  return \`Mastering \${skill} with AI\`;
};

console.log(learn('React'));`;

  const handleRun = () => {
    setOutput("Mastering React with AI");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="glass-futuristic rounded-xl p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-red-500"></div>
          <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
        </div>
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="ghost"
            onClick={handleCopy}
            className="text-xs"
          >
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </Button>
          <Button
            size="sm"
            onClick={handleRun}
            className="text-xs bg-primary/20 hover:bg-primary/30"
          >
            <Play className="h-4 w-4 mr-1" />
            Run
          </Button>
        </div>
      </div>

      <pre className="bg-background/50 rounded-lg p-4 overflow-x-auto mb-4">
        <code className="text-sm font-mono text-foreground">
          {code}
        </code>
      </pre>

      {output && (
        <div className="bg-terminal/5 border border-primary/20 rounded-lg p-4">
          <div className="text-xs text-muted-foreground mb-1">Output:</div>
          <div className="text-sm font-mono text-primary">{output}</div>
        </div>
      )}
    </div>
  );
};
